import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BASE_URL_TOKEN, SearchCriteria, SystemAnnouncement } from '@raptor-fe/core';
import { HttpClient } from '@angular/common/http';
import { LoadingHeaders } from '../web-loading-service/web-loading-headers';

@Injectable({ providedIn: 'root' })
export class SystemAnnouncementService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = inject(BASE_URL_TOKEN);
    private readonly path = `${this.baseUrl}v1/systemAnnouncement`;
    private httpHeadersWithNoLoading = LoadingHeaders.httpHeadersWithNoLoading();

    getActive(): Observable<SystemAnnouncement[]> {
        return this.http.get<SystemAnnouncement[]>(this.path, { headers: this.httpHeadersWithNoLoading });
    }

    get(id: string): Observable<SystemAnnouncement> {
        return this.http.get<SystemAnnouncement>(`${this.path}/${id}`);
    }

    save(entry: SystemAnnouncement, isNew: boolean): Observable<SystemAnnouncement> {
        return isNew ? this.http.post<SystemAnnouncement>(this.path, entry) : this.http.put<SystemAnnouncement>(this.path, entry);
    }

    delete(id: string): Observable<void> {
        return this.http.delete<void>(`${this.path}/${id}`);
    }

    search(criteria: SearchCriteria, showLoading = true): Observable<SystemAnnouncement[]> {
        const headers = showLoading ? undefined : this.httpHeadersWithNoLoading;
        return this.http.post<SystemAnnouncement[]>(`${this.path}/search`, criteria, { headers });
    }
}
